export const version = process.env.REACT_APP_VERSION || "v0.0.0"